import React from 'react'
import './about.css'

function About() {
  return (
    <div>
      <div class="container">
   <div class="content">
    <div class="header">
     <img alt="Farmor logo" src="https://cdn-icons-png.flaticon.com/128/346/346195.png" width="20"/>
     <span style={{color: '#4CAF50', fontWeight: 'bold',marginLeft:10}}>
      About Sadapoorna
     </span>
    </div>
    <h1 data-aos="fade-right">
     Organic &amp;
     <br/>
     Healthy Rice
    </h1>
    <p>
    Sadapoorna is a premium rice brand dedicated to delivering the purest and most authentic rice to households across India. Our name, meaning "Always Pure," reflects our core commitment to quality, health, and tradition. We source our rice directly from trusted farmers who practice sustainable and chemical-free farming methods, ensuring that every grain we offer is naturally grown, hygienically processed, and rich in nutrition.
    </p>
    <div class="section">
     <img alt="Agriculture &amp; Foods icon" height="50" src="https://cdn-icons-png.flaticon.com/128/2516/2516632.png" width="50"/>
     <div>
      <h3>
       Pure & Natural
      </h3>
      <p>
      Free from harmful chemicals and preservatives
      </p>
     </div>
    </div>
    <div class="section">
     <img alt="Vegetables &amp; Fruits icon" height="50" src="https://cdn-icons-png.flaticon.com/128/10632/10632405.png" width="50"/>
     <div>
      <h3>
       Farm-to-Table
      </h3>
      <p>
      Direct sourcing from ethical, sustainable farms
      </p>
     </div>
    </div>
    <div class="section" data-aos="fade-right">
     <img alt="Food Beverage icon" height="50" src="https://cdn-icons-png.flaticon.com/128/3859/3859737.png" width="50"/>
     <div>
      <h3>
       Hygienic Processing
      </h3>
      <p>
      Clean, modern facilities that retain nutritional value
      </p>
     </div>
    </div>
    <div class="section" data-aos="fade-right">
     <img alt="Animal Nutrition icon" height="50" src="https://cdn-icons-png.flaticon.com/128/9756/9756984.png" width="50"/>
     <div>
      <h3>
       Rich Taste & Aroma
      </h3>
      <p>
      Perfect for everyday meals and special occasions
      </p>
     </div>
    </div>
   </div>
   <div class="image-section">
    <img alt="Image of a farm with rows of crops" style={{width:'80%',height:'80%'}} src="https://plus.unsplash.com/premium_photo-1705338026411-00639520a438?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8cmljZXxlbnwwfHwwfHx8MA%3D%3D"/>
    <img alt="Image of a tractor in a field" class="small-image" style={{width:'400px',height:'400px'}} src="https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2V8ZW58MHx8MHx8fDA%3D"/>
   </div>
  </div>
    </div>
  )
}

export default About
